<template>
    <div> 
        <div :class="{ 
            'formeditor__sidebar': $route.params.action === 'graph',
            'row': $route.params.action === 'detail'
        }">
            <div :class="{ 'col-12': $route.params.action === 'detail' }">
                <div v-if="selectedNode && $route.params.action === 'graph'" class="row">
                    <button 
                        class="btn btn-secondary ml-auto"
                        @click="resetNode()"
                    >
                        <b-icon icon="x" width="1em" height="1em" class="ml-2" /> {{ $t('deselect-node') }}
                    </button>
                </div>
                <NodeEditor 
                    v-if="selectedNode" 
                    :node="selectedNode" 
                    :options="nodeEditorOptions"
                    @nodeChanges="handleNodeEditor" 
                    ref="nodeeditor"
                    :viewOnly="!$UserSession.hasPriv.call(this, 'CURRICULUM_MANAGE')" 
                />
                <!-- BEGIN LEARNINGOUTCOMES LIST -->
                <div v-if="!selectedNode && $route.params.action === 'graph'">
                    <h3><strong>{{ $t('learning-outcomes') }}</strong></h3>
                    <div>
                        <select class="form-control" v-model="selectedOutcomesGroup">
                            <option :value="{}" selected>{{ $t('select-outcome-group') }}</option>
                            <option v-for="outcomesGroup in outcomesGroups" 
                                :value="outcomesGroup" 
                                :key="outcomesGroup.id"
                                type="text" 
                                class="form-control"
                            >
                                {{ outcomesGroup.title }}
                            </option>
                        </select>
                    </div>
                    <input type="text" v-model="query" class="form-control mt-1 mb-1" :placeholder="$t('search')" />

                    <div class="row d-flex justify-content-end">
                        <CheckboxInput :value="linked_outcomes" @input="linkedToggle()"
                            :label="$t('display-linked-outcomes')" />
                    </div>
                    <div class="list-group mt-1">
                        <div class="list-group-item" v-for="(outcome, key) in displayLearningOutcomes" :key="key"
                            @click="highlightLearningOutcome(outcome.id);"
                            :class="{ active: outcome.id === selectedOutcome }">
                            <template v-if="outcome.code">{{ outcome.code }}: </template>
                            {{ outcome.title }}
                            <div class="float-right" v-if="$UserSession.hasPriv.call(this, 'CURRICULUM_MANAGE')">
                                <a class="btn btn-light btn-xs ml-1" style="margin: 0 0 0 0" data-toggle="tooltip"
                                    data-placement="top" :title="$t('go')"
                                    @click.stop="$router.push(`/curriculum-mapping/learning-outcomes/edit/${outcome.id}`)">
                                    <b-icon icon="arrow-bar-right" width="1em" height="1em"></b-icon>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- END LEARNINGOUTCOMES LIST -->
            </div>
        </div>

        <div :class="{ 'formeditor__mainwindow': $route.params.action === 'graph' }">
            <Dendogram v-if="loaded" 
                :hierarchy="hierarchy" 
                @selectedNode="handleSelectedNode" 
                ref="dendogram" 
                :options="dendogramOptions"
                :isGraph="$route.params.action === 'graph'"
            />
            <div v-else class="loading-wrapper d-flex align-items-center justify-content-center" style="height: 100vh;">
                <div class="card border-light" style="width: 18rem;">
                    <div class="card-body text-center">
                        <b-spinner variant="primary" label="Spinning" font-scale="10.5" />
                        <h5 class="card-title">{{ $t("loading") }}</h5>
                        <p class="card-text">
                            {{ $t("loading-hierarchy") }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div style="position: fixed; bottom: 0px; left: 50px; right: 300px; z-index: 1000;">
            <NodeDrilldownSearch 
                v-if="loaded"
                :nodes="nodes"
                @filtered-nodes="handleFilteredNodes"
                :graphView = "$route.params.action === 'graph' ? true : false"            />
        </div>

    </div>
</template>
<script>
import Dendogram from "src/components/CurriculumMapping/Dendogram.vue"
import NodeEditor from "src/components/CurriculumMapping/NodeEditor.vue"
import NodeDrilldownSearch from "src/components/CurriculumMapping/NodeDrilldownSearch.vue";

export default {
    components: {
        Dendogram,
        NodeEditor,
        NodeDrilldownSearch
    },
    data() {
        return {
            learningoutcomes: [],
            hierarchy: {},
            loaded: false,
            root: null,
            selectedNode: null,
            outcomesGroups: null,
            query: '',
            selectedOutcome: null,
            selectedOutcomes: [],
            selectedOutcomesGroup: {},
            linked_outcomes: false,
            nodeEditorOptions: {
                breadcrumbs: this.$route.params.action === 'detail' ? true : false,
                newNodeEditor: true,
                displayChildren: true,
                learningOutcomes: true,
                spareChildrenNodes: true,
                graphView: this.$route.params.action === 'graph' ? true : false,
                nodeLinks: this.$route.params.action === 'graph' ? true : false
            },
            dendogramOptions:{
                    wrapperStyle : {
                        position: this.$route.params.action === 'graph' ? 'fixed' : 'relative', 
                        top: '0', 
                        bottom:'0',
                        left: '50px', 
                        right: this.$route.params.action === 'graph' ? '300px' : '0', 
                        overflow: this.$route.params.action === 'graph' ? 'hidden' : null,
                        display: this.$route.params.action !== 'graph' ? 'flex' : null,
                        alignItems: this.$route.params.action !== 'graph' ? 'center' : null,
                        justifyContent: this.$route.params.action !== 'graph' ? 'center' : null,
                        minHeight: this.$route.params.action !== 'graph' ? '200px' : 'auto',
                        height: 'auto',
                        padding: this.$route.params.action !== 'graph' ? '20px 0' : '0'
                    },
                    chartStyle : {
                        position: this.$route.params.action === 'graph' ? 'absolute' : 'relative',
                        top: this.$route.params.action === 'graph' ? '0' : null,
                        left:' 0',
                        /*width: '100%',
                        height: '100%',*/
                        width: this.$route.params.action === 'graph' ? '100%' : '100%',
                        height: this.$route.params.action === 'graph' ? '100%' : '100%',
                        cursor: this.$route.params.action === 'graph' ? 'move' : 'default',
                        margin: this.$route.params.action === 'graph' ? null : 'auto'
                    },
                    zoomable : this.$route.params.action === 'graph' ? true : false,
                    draggable : this.$route.params.action === 'graph' ? true : false
            },
            nodes: [],
            filteredNodes: []
        }

    },
    mounted() {
        this.getHierarchy(this.$route.params.id).then((node) => {
            if(this.$route.params.action === 'detail') this.selectedNode = node
        });

        this.getNodes();
        this.listLearningOutcomes();
        this.listLearningOutcomeGroups();
    },
    methods: {
        handleSelectedNode(node) {
            this.selectedNode = node;
            // FIX this from API c.f. shortcut ticket 1150
            const original = this.selectedNode.learningoutcomes?.original ? this.selectedNode.learningoutcomes.original : [];
            const linked = this.selectedNode.learningoutcomes?.linked ? this.selectedNode.learningoutcomes.linked : [];

            // Combine both arrays safely
            const joint_ids = [
                ...original,
                ...linked
            ];

            this.selectedNode.learningoutcomes.joint = this.learningoutcomes.filter(obj => joint_ids.includes(obj.id))
            
            this.query = ''
        },
        handleNodeEditor(payload) {
            // Refresh hierarchy
            this.getHierarchy(this.$route.params.id).then(() => {
                // Three possible cases: added, saved and deleted
               this.$refs.dendogram.updateChart(); 

                const node_to_select = payload.action == 'node_deleted' ? payload.data.parent_id : payload.data.id
                this.$refs.dendogram.highlightNodeAndPath(this.getNode(this.hierarchy, node_to_select))
            })

        },
        highlightLearningOutcome(outcome) {
            // Highlight nodes in the dendogram
            this.$refs.dendogram.highlightMatchingNodes(outcome,
                this.linked_outcomes ? 'learningoutcomes.original' : 'learningoutcomes.original'
            );

            //Set the selectedOutcome so the learning outcome is highlighted
            this.selectedOutcome = outcome;
        },
        resetNode() {
            this.selectedNode = null;
            this.$refs.dendogram.resetPathAndNodes();
        },
        linkedToggle() {
            this.linked_outcomes = !this.linked_outcomes;
            if (this.selectedOutcome) this.highlightLearningOutcome(this.selectedOutcome.id);
        },
        /**
        * Stores a hierarchy emanating from the given root node
        * @params {string} id - The id of the root node
        *
        */
        getHierarchy(id) {
            return this.$cfetch(`${this.$settings.APIBaseURL}/curriculummap/gethierarchy`, {
                method: "post",
                data: {
                    id: id
                }
            }).then((res) => {
                if (res.status === "SUCCESS") {
                    this.hierarchy = res.result[0];

                    const joint_ids = [
                        ...this.hierarchy.learningoutcomes.original,
                        ...this.hierarchy.learningoutcomes.linked
                    ]

                    this.hierarchy.learningoutcomes.joint = this.learningoutcomes.filter(obj => joint_ids.includes(obj.id))
                    
                    return this.hierarchy;
                }
            }).catch(error => {
                this.$log.error.call(this, error);
            }).finally(() => { this.loaded = true });
        },
        /**
        * Gets a node from the existing hierrchy
        * @params {string} id - The id of the node we are searching for
        *
        */
        getNode(root, id) {
            if (root.id === id) return root; // Check if the current node's id matches the targetId

            for (let child of root.children) { // Iterate over the children and search recursively
                const result = this.getNode(child, id);
                if (result) return result; // If found, return the node
            }

            return null; // If not found anywhere, return null
        },
        listLearningOutcomes() {
            this.$cfetch(`${this.$settings.APIBaseURL}/learningoutcome/list`, {
                method: "post",
                data: {
                    status : 1
                }
            })
            .then((res) => {
                if (res.status === "SUCCESS") {
                    this.learningoutcomes = res.results;
                }
            }).catch(error => {
                this.$log.error.call(this, error);
            });
        },
        listLearningOutcomeGroups() {
            this.$cfetch(`${this.$settings.APIBaseURL}/learningoutcome/group/list`, {
                method: "post"
            })
            .then((res) => {
                if (res.status === "SUCCESS") {
                    this.outcomesGroups = res.results;
                }
            }).catch(error => {
                this.$log.error.call(this, error);
            });
        },
        getNodes(){
            this.$cfetch(`${this.$settings.APIBaseURL}/curriculummap/listnodes`, {
                method: 'post',
                data: {
                    id: this.$route.params.id,
                    string: true,
                    all_nodes: false
                }
            })
            .then((res) => {
                if (res.status === "SUCCESS") {
                    if(res.results) this.nodes = res.results;
                }
                else {
                    console.log(`Not loaded`);
                }
            });
        },
        handleFilteredNodes(val) {
            this.filteredNodes = val;
            return val;
        }

    },
    computed: {
        displayLearningOutcomes() {
            if (this.query || this.selectedOutcomesGroup.id) {
                const query = this.query.toLowerCase();
                return this.learningoutcomes.filter(outcome => {
                    return outcome.title.toLowerCase().includes(query)
                        && (!this.selectedOutcomesGroup.id || outcome.learningoutcomegroup_id === this.selectedOutcomesGroup.id);
                });
            }
            return this.learningoutcomes;
        },
        displayMode() {
            return this.$route.params.action;
        }
    }
};
</script>
<style>
.node circle {
    fill: #ccc;
    stroke: #ccc;
    stroke-width: 2px;
}

.node text {
    font-size: 12px;
}

.highlighted circle {
    fill: red;
    stroke: red;
    stroke-width: 2px;
}

.highlighted {
    stroke: red !important;
    stroke-width: 2px;
}

.link {
    stroke: green;
}
</style>
